import {skipToken} from '@reduxjs/toolkit/query'

import {useGetHotelQuery} from '@vio/core/src/sapi/services/searchApi'

export const useGetHotelDetails = (hotelId?: string) =>
  useGetHotelQuery(hotelId ? {hotelId} : skipToken)
